export default {
  // superadmin
  superadmin: [
    {
      title: true,
      name: 'Main',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'My Tickets',
      url: '/dashboard',
      icon: 'fa fa-ticket'
    },
    {
      name: 'Customer Tickets',
      url: '/support/tickets/external',
      icon: 'fa fa-question-circle'
    },
    
    {
      name: 'Open Ticket',
      url: '/support/tickets/create',
      icon: 'fa fa-support',
    },
    {
      title: true,
      name: 'Administration',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Manage Users',
      url: '/admin/users',
      icon: 'icon-user'
    },
    {
      name: 'Manage Projects',
      url: '/admin/projects',
      icon: 'icon-menu'
    },
    {
      name: 'KB - Pages',
      url: '/docs/knowledgebase/pages',
      icon: 'fa fa-book'
    },
    {
      name: 'KB - Groups',
      url: '/docs/knowledgebase/groups',
      icon: 'fa fa-folder-open'
    },
  ],
  // admin
  admin: [
    {
      title: true,
      name: 'Main',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'My Tickets',
      url: '/dashboard',
      icon: 'fa fa-ticket'
    },
    {
      name: 'Customer Tickets',
      url: '/support/tickets/external',
      icon: 'fa fa-question-circle'
    },

    {
      name: 'Open Ticket',
      url: '/support/tickets/create',
      icon: 'fa fa-support',
    },
    {
      title: true,
      name: 'Administration',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Manage Users',
      url: '/admin/users',
      icon: 'icon-user'
    }
  ],
  // -- warehouse manager
  // brandUser
  endUser: [
    {
      title: true,
      name: 'Main',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'My Tickets',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'Customer Tickets',
      url: '/support/tickets/external',
      icon: 'fa fa-question-circle'
    },

    {
      name: 'Open Ticket',
      url: '/support/tickets/create',
      icon: 'fa fa-support',
    }
  ]
  // -- endUser
};
